var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHolder2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 510,
    viewBox: "0 0 510 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 255C0 395.833 114.167 510 255 510H510V255C510 114.167 395.833 0 255 0C114.167 0 0 114.167 0 255Z",
    fill: "url(#paint0_linear_28_1729)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_1729",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 510,
    height: 510
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 255C0 395.833 114.167 510 255 510H510V255C510 114.167 395.833 0 255 0C114.167 0 0 114.167 0 255Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_1729)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: -11,
    width: 403,
    height: 533,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_28_1729",
    transform: "matrix(0.000397141 0 0 0.000300277 0 -0.00311416)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_1729",
    x1: 255,
    y1: 510,
    x2: 255,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6652",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6652"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolder2);
export default __webpack_public_path__ + "static/media/holder2.c6a204c1da2772c74a87c9602bbf6032.svg";
export { ForwardRef as ReactComponent };